import React, { useState } from "react";
import { Table, Tag, Button, Modal, Descriptions, Space, Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";

const OtherMachineryDetailsTable = ({ data }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedMachinery, setSelectedMachinery] = useState(null);

  const showModal = (record) => {
    setSelectedMachinery(record);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedMachinery(null);
  };

  const columns = [
    {
      title: "Machinery Name",
      dataIndex: "machinary_name",
      key: "machinary_name",
    },
    {
      title: "Machinery Maker",
      dataIndex: "machinary_make",
      key: "machinary_make",
    },
    {
      title: "Machinery Model",
      dataIndex: "machinary_model",
      key: "machinary_model",
    },

    {
      title: "Selected Parameters",
      dataIndex: "selected_parameters",
      key: "selected_parameters",
      width: "50%",
      render: (params) =>
        params && params.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {params.map((param, index) => (
              <Tag color="blue" key={index}>
                {param}
              </Tag>
            ))}
          </div>
        ) : (
          <span>—</span>
        ),
    },

    {
      title: "Other Parameters",
      dataIndex: "other_parameters",
      key: "other_parameters",
      width: "20%",
      render: (params) =>
        params && params.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {params.map((item, index) => (
              <Tag color="green" key={index}>
                {item.name} ({item.unit})
              </Tag>
            ))}
          </div>
        ) : (
          <span>—</span>
        ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="View Details">
            <Button
              type="primary"
              icon={<EyeOutlined />}
              onClick={() => showModal(record)}
              size="small"
            >
              View
            </Button>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        pagination={{ pageSize: 5 }}
        bordered
        className="custom-table"
      />

      <Modal
        title="Machinery Details"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={700}
      >
        {selectedMachinery && (
          <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="Machinery Name">
              {selectedMachinery.machinary_name}
            </Descriptions.Item>
            <Descriptions.Item label="Maker">{selectedMachinery.machinary_make}</Descriptions.Item>
            <Descriptions.Item label="Model">{selectedMachinery.machinary_model}</Descriptions.Item>
            <Descriptions.Item label="Selected Parameters">
              {Array.isArray(selectedMachinery.selected_parameters) &&
              selectedMachinery.selected_parameters.length > 0 ? (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                  {selectedMachinery.selected_parameters.map((param, index) => (
                    <Tag color="blue" key={index}>
                      {param}
                    </Tag>
                  ))}
                </div>
              ) : (
                "—"
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Other Parameters">
              {Array.isArray(selectedMachinery.other_parameters) &&
              selectedMachinery.other_parameters.length > 0 ? (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                  {selectedMachinery.other_parameters.map((item, index) => (
                    <Tag color="green" key={index}>
                      {item.name} ({item.unit})
                    </Tag>
                  ))}
                </div>
              ) : (
                "—"
              )}
            </Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
    </>
  );
};

export default OtherMachineryDetailsTable;
